import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarLeadPayload, paramsListLeads, atualizarLeadPayload } from '../../interfaces/leads'

export function novoLead (payload: cadastrarLeadPayload) {
    return BASEURLGESTTOR.post('/leads', payload)
}

export function lisatarLeads (params: paramsListLeads) {
    return BASEURLGESTTOR.get (`/leads?nome=${params.nome}&situacao=${params.situacao}&idResponsavel=${params.idResponsavel}`)
}

export function atualizarLead (idLead: string, payload: atualizarLeadPayload) {
    return BASEURLGESTTOR.patch(`/leads?idLead=${idLead}`, payload)
}

export function deletarLead (idLead: string) {
    return BASEURLGESTTOR.delete(`/leads?idLead=${idLead}`)
}
